import axios from '../../axios'

export default {
  getList({ commit }, params) {
    commit('SET_STATE', { action: 'listLoading', data: true })
    return new Promise((resolve, reject) => {
      axios
        .get('/admin/voice-by-sangat', { params })
        .then((response) => {
          commit('SET_STATE', { action: 'records', data: response.data.data.results })
          commit('SET_STATE', { action: 'total', data: response.data.data.totalResults })
          commit('SET_STATE', { action: 'FilteredCount', data: response.data.data.totalResults })
          commit('SET_STATE', { action: 'listLoading', data: false })
          resolve(response.data)
        })
        .catch((error) => {
          commit('SET_STATE', { action: 'listLoading', data: false })
          reject(error.response.data)
        })
    })
  },

  create({ commit }, data) {
    commit('SET_STATE', { action: 'saveLoading', data: true })
    return new Promise((resolve, reject) => {
      axios
        .post('/admin/voice-by-sangat', data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          commit('SET_STATE', { action: 'saveLoading', data: false })
          resolve(response.data)
        })
        .catch((error) => {
          commit('SET_STATE', { action: 'saveLoading', data: false })
          reject(error.response.data)
        })
    })
  },

  update({ commit }, { id, data }) {
    commit('SET_STATE', { action: 'saveLoading', data: true })
    return new Promise((resolve, reject) => {
      axios
        .patch(`/admin/voice-by-sangat/${id}`, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          commit('SET_STATE', { action: 'saveLoading', data: false })
          resolve(response.data)
        })
        .catch((error) => {
          commit('SET_STATE', { action: 'saveLoading', data: false })
          reject(error.response.data)
        })
    })
  },

  updateStatus({ _commit }, { id, status }) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/admin/voice-by-sangat/status/${id}`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response.data)
        })
    })
  },

  delete({ _commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/admin/voice-by-sangat/${id}`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response.data)
        })
    })
  },

  updateSequence({ _commit }, { data }) {
    return new Promise((resolve, reject) => {
      axios
        .patch('/admin/voice-by-sangat/update-sequence', { data })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response.data)
        })
    })
  }
}
